import React from 'react'
import { Menu } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useApp } from '@/hooks'
import {
  TeamOutlined,
  UserOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons'

export const MainMenu = () => {
  const { setVisible } = useApp()
  const location = useLocation()
  const selectedKeys = [location.pathname]

  const primaryItems = [
    {
      key: '/admin/organizations',
      icon: <TeamOutlined />,
      label: <Link to="/admin/organizations">Organizations</Link>,
    },
    {
      key: '/admin/users',
      icon: <UserOutlined />,
      label: <Link to="/admin/users">Users</Link>,
    },
    {
      key: '/admin/events',
      icon: <CalendarOutlined />,
      label: <Link to="/admin/events">Events</Link>,
    },
  ]

  const allItems = [
    ...primaryItems,
    {
      key: '/admin/approvals',
      icon: <CheckCircleOutlined />,
      label: <Link to="/admin/approvals">Approvals</Link>,
    },
  ]

  return (
    <Menu
      className="main-menu"
      selectedKeys={selectedKeys}
      mode="inline"
      onClick={() => setVisible(false)}
      items={allItems}
    />
  )
}
